import type { TenantSettings } from '@/shared/api/resources';

/**
 * So o que mudou no formulario, comparado com o que o servidor devolveu.
 *
 * O formulario de configuracoes mandava a configuracao inteira, inclusive o dominio
 * proprio que ele nem mostra, e o servidor passava a exigir a funcionalidade de
 * dominio proprio de quem so trocou uma cor (defeito 1 de "Empresa" do Anexo C do
 * 47). Mandar so a diferenca resolve na origem; o servidor tambem passou a comparar
 * com o gravado.
 */
export function alteracoes(
  original: Partial<TenantSettings>,
  atual: Partial<TenantSettings>,
): Partial<TenantSettings> {
  const saida: Record<string, unknown> = {};
  for (const chave of Object.keys(atual) as (keyof TenantSettings)[]) {
    if (JSON.stringify(atual[chave]) !== JSON.stringify(original[chave])) {
      saida[chave] = atual[chave];
    }
  }
  return saida;
}
